import React, { useContext, useMemo } from 'react'
import { useHasReceptor } from 'src/pages/Receptors/receptors.hooks'
import { StandardOpenModalButton } from 'src/components/ModalForms/ModalButtons'
import { AddWorkflowEvidenceModal } from 'src/components/ModalForms/Evidence/AddWorkflowEvidence'
import { StandardButtonSize, StandardButtonVariant } from '../../Buttons'
import { ModalFormId } from '../../../ModalForms'
import { AddEvidenceModal } from '../../../ModalForms/Evidence/AddEvidence/AddEvidenceModal'
import { ReceptorScanSpinner } from '../../../../Throbber/ReceptorScanSpinner'
import { AddConnectionModalToggle } from '../../../../pages/Controls/ControlsShowPage/ConnectedGrid'
import ReceptorScanContext from '../../../../context/ReceptorScanStatus'
import { DateRangeFilter } from '../../TrusteroDateRange/DateRangeFilter'
import { FlexRow } from '../../Flex'
import {
  TabPanelButtonGroup,
  TabPanelNoteHeader,
  TabPanelNoteItem,
} from './styles'
import { EvidenceTabNoteProps } from './TabNote.components'

export const EvidenceTabNote = ({
  controlId,
  name,
  currentAudit,
  isNotApplicable,
  setDateRange,
  dateRange,
}: EvidenceTabNoteProps): JSX.Element => {
  const { receptorScanRunning } = useContext(ReceptorScanContext)

  const { data: HasJiraReceptor } = useHasReceptor('trr-jira-workflow', false)
  const hasJiraWorkflowReceptor = useMemo(
    () => HasJiraReceptor?.getHasReceptor() || false,
    [HasJiraReceptor],
  )

  const { data: HasSnowReceptor } = useHasReceptor(
    'trr-servicenow-workflow',
    false,
  )
  const hasServiceNowWorkflowReceptor = useMemo(
    () => HasSnowReceptor?.getHasReceptor() || false,
    [HasSnowReceptor],
  )

  const addEvidenceModalId = isNotApplicable
    ? ModalFormId.NA_INFO
    : ModalFormId.ADD_EVIDENCE

  const addWorkflowEvidenceModalId = isNotApplicable
    ? ModalFormId.NA_INFO
    : ModalFormId.ADD_WORKFLOW_EVIDENCE

  const addConnectionModalId = isNotApplicable
    ? ModalFormId.NA_INFO
    : ModalFormId.ADD_EVIDENCE_GENERATOR_EVIDENCE_TAB

  return (
    <>
      <TabPanelNoteItem>
        <TabPanelNoteHeader>
          <DateRangeFilter
            currentAudit={currentAudit?.getId()}
            dateRange={dateRange}
            setDateRange={setDateRange}
            additionalToolTip={!!currentAudit}
            additionalToolTipBody="Auditors only consider evidence and tests from within the date range of your current audit."
          />
          <TabPanelButtonGroup>
            <FlexRow gap={12}>
              {(hasJiraWorkflowReceptor || hasServiceNowWorkflowReceptor) && (
                <StandardOpenModalButton
                  modalId={addWorkflowEvidenceModalId}
                  variant={StandardButtonVariant.SECONDARY}
                  text="Create Workflow Task"
                  size={StandardButtonSize.SMALL}
                />
              )}
              <AddConnectionModalToggle
                modalFormId={addConnectionModalId}
                buttonVariant={StandardButtonVariant.SECONDARY}
                controlId={controlId}
                isNotApplicable={isNotApplicable}
              />
              <StandardOpenModalButton
                modalId={addEvidenceModalId}
                text="Add Evidence"
                size={StandardButtonSize.SMALL}
              />
            </FlexRow>
          </TabPanelButtonGroup>
        </TabPanelNoteHeader>
        <ReceptorScanSpinner show={receptorScanRunning} />
      </TabPanelNoteItem>
      <AddEvidenceModal controlId={controlId} name={name} openOnDrag />
      <AddWorkflowEvidenceModal controlId={controlId} name={name} openOnDrag />
    </>
  )
}
